import {
  TextField as AriaTextField,
  TextFieldProps as AriaTextFieldProps,
  ValidationResult,
} from "react-aria-components";
import { Description, FieldError, Input, Label } from "./Form";
import { composeTailwindRenderProps } from "../../cn";
import { IconType } from "../../foundations/Icons/types";

export interface TextFieldProps extends AriaTextFieldProps {
  label?: JSX.Element | string;
  leftIcon?: IconType;
  description?: string;
  placeholder?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
  rightElement?: JSX.Element;
  size?: "l" | "sm";
}

export function TextField({
  leftIcon,
  label,
  description,
  errorMessage,
  placeholder,
  rightElement,
  size,
  ...props
}: TextFieldProps) {
  return (
    <AriaTextField
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        "flex flex-col gap-1",
      )}
    >
      {label && <Label>{label}</Label>}
      <Input
        placeholder={placeholder}
        leftIcon={leftIcon}
        rightElement={rightElement}
        size={size}
      />
      {description && <Description>{description}</Description>}
      <FieldError>{errorMessage}</FieldError>
    </AriaTextField>
  );
}
